import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    text: 'Llevaba meses sintiéndome lejos de Dios. Este libro no me dio sermones, me dio permiso para estar triste y aun así buscarlo. Fue como un abrazo en la oscuridad.',
    author: 'Ana María G.',
    role: 'Madre de familia'
  }, {
    text: 'No es un libro para leer rápido. Es para leer un poquito y dejar que te sane. Me enseñó que mi dolor no espanta a Dios.',
    author: 'Carlos R.',
    role: 'Empresario'
  }, {
    text: "Justo lo que necesitaba en mi Cuaresma más difícil. Sentí que alguien por fin entendía que no podía 'estar feliz' todo el tiempo.",
    author: 'Lucía M.',
    role: 'Estudiante'
  }];
  return <section className="py-24 px-6 bg-[var(--bg-surface)] border-y border-[var(--bg-elevated)]" data-id="element-298">
      <div className="max-w-[800px] mx-auto" data-id="element-299">
        <div className="text-center mb-16" data-id="element-300">
          <h2 className="text-3xl font-serif text-[var(--text-heading)] mb-6" data-id="element-301">
            "No estamos construyendo una vida sin problemas..."
          </h2>
          <p className="text-xl text-[var(--accent)] font-serif italic" data-id="element-302">
            "...estamos construyendo un corazón con refugio."
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-303">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-[var(--bg-deep)] p-6 rounded relative pt-10 border border-[var(--bg-elevated)]" data-id="element-304">
              <Quote className="absolute top-6 left-6 w-6 h-6 text-[var(--accent)] opacity-20" data-id="element-305" />
              <p className="text-[var(--text-primary)] text-sm leading-relaxed mb-6 italic" data-id="element-306">
                "{t.text}"
              </p>
              <div className="border-t border-[var(--bg-elevated)] pt-4" data-id="element-307">
                <p className="text-[var(--text-heading)] text-xs font-bold uppercase tracking-wider" data-id="element-308">
                  {t.author}
                </p>
                <p className="text-[var(--text-muted)] text-[10px]" data-id="element-309">{t.role}</p>
              </div>
            </motion.div>)}
        </div>

        <p className="text-center text-[var(--text-muted)] text-sm mt-12 opacity-60" data-id="element-310">
          Miles de personas han descubierto que 5 minutos de honestidad valen
          más que horas de religiosidad.
        </p>
      </div>
    </section>;
}